import React from 'react';
import { useAppState } from '../../state';

export default function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthReady } = useAppState();

  if (!isAuthReady) {
    return null;
  }

  return <>{children}</>;
}
